module.exports = __webpack_public_path__ + "static/avatar-014c484976ac334e4ea043ba6928fbd8.jpg";